import { useEffect, useState } from 'react'
import { useOnline } from '@/app/stay/useOnline'
import { cachedPhotoUrl, cachePhotos } from '@/services/offline-cache'

/**
 * Fotos de las instrucciones disponibles sin conexión (inventario D39): con conexión se guardan en la Cache
 * API y se usan las URL originales; sin conexión se sirven como blob URL desde la caché. Una foto que no se
 * pudo guardar (sin CORS) queda en null y la pantalla muestra el marcador con la descripción.
 */
export function usePhotos(urls: string[]): Record<string, string | null> {
  const online = useOnline()
  const joined = urls.join('|')
  const [offlineUrls, setOfflineUrls] = useState<Record<string, string | null>>({})

  useEffect(() => {
    const list = joined ? joined.split('|') : []
    if (list.length === 0) return
    if (online) {
      void cachePhotos(list)
      return
    }
    let cancelled = false
    const created: string[] = []
    void Promise.all(list.map(async (url) => [url, await cachedPhotoUrl(url)] as const)).then((entries) => {
      for (const [, blob] of entries) if (blob) created.push(blob)
      if (!cancelled) setOfflineUrls(Object.fromEntries(entries))
    })
    return () => {
      cancelled = true
      for (const blob of created) URL.revokeObjectURL(blob)
    }
  }, [joined, online])

  return Object.fromEntries(urls.map((url) => [url, online ? url : (offlineUrls[url] ?? null)]))
}
